const variables = {
  // breakpoints,
  "breakpoint-small": "(min-width: 768px)",
  "breakpoint-medium": "(min-width: 1024px)",
  "breakpoint-large": "(min-width: 1280px)",
  "breakpoint-up-to-small": "(max-width: 767px)",
  "breakpoint-up-to-medium": "(max-width: 1023px)",

  // dimensions
  "scale-1": "0.4rem",
  "scale-2": "0.8rem",
  "scale-3": "1.2rem",
  "scale-4": "1.6rem",
  "scale-5": "2.0rem",
  "scale-6": "2.4rem",
  "scale-7": "2.8rem",
  "scale-8": "3.2rem",
  "scale-9": "3.6rem",
  "scale-10": "4rem",
  "scale-11": "4.4rem",
  "scale-12": "4.8rem",
  "scale-20": "8rem",
  "scale-30": "12rem",
};

module.exports = variables;
